import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { StudentlifeRoutingModule } from './studentlife-routing.module';
import { StudentlifeListComponent } from './studentlife-list/studentlife-list.component';
import { StudentlifeCreateComponent } from './studentlife-create/studentlife-create.component';

@NgModule({
  declarations: [StudentlifeListComponent, StudentlifeCreateComponent],
  imports: [
    CommonModule,
    StudentlifeRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class StudentlifeModule { }
